import { Button, Div } from '@kizi/core-components';
import React from 'react';
import { NonPurchasableText } from './NonPurchasableText';
import { Price } from './Price';
import { isMobile } from '@kizi/comparator-components';

interface PriceButtonCompProps {
  discountIncluded: number;
  priceInitialValue: number;
  data: any;
  priceProps: any;
  shouldOpenApplyModal: boolean;
  showConfirmationModal: boolean;
  shouldShowModal: (showConfirmationModal: boolean) => void;
  handleSubmit: () => void;
  onMobileCompare?: (id: string) => void;
  hidePrice?: boolean;
  forceCTAButton?: boolean;
  isPurchasableProduct: boolean;
  isNotPurchasableProduct: boolean;
}

export const PriceButtonComp: React.FC<PriceButtonCompProps> = React.memo(
  ({
    discountIncluded,
    priceInitialValue,
    data,
    priceProps,
    shouldOpenApplyModal,
    shouldShowModal,
    showConfirmationModal,
    handleSubmit,
    hidePrice = false,
    forceCTAButton = false,
    isPurchasableProduct,
    isNotPurchasableProduct,
  }) => {
    const showCTAButton = !isMobile() || forceCTAButton;

    return (
      <Div
        display="flex"
        flexDirection="column"
        height={!forceCTAButton ? '100%' : 'unset'}
        justifyContent={'space-between'}
      >
        {!hidePrice && (
          <Price
            discount={discountIncluded}
            initialValue={priceInitialValue}
            value={data?.priceInfo?.total}
            data={data}
            {...priceProps}
          />
        )}

        {showCTAButton && (
          <Div>
            {isPurchasableProduct && (
              <Button
                onClick={
                  shouldOpenApplyModal
                    ? () => shouldShowModal(!showConfirmationModal)
                    : handleSubmit
                }
                variant="productCardPrimary"
                className="buildButton"
                width="100%"
              >
                Bekijk
              </Button>
            )}

            {isNotPurchasableProduct && <NonPurchasableText />}
          </Div>
        )}
      </Div>
    );
  },
);
